import { OrderByValue } from './interfaces';
import { cloneDeep } from 'lodash';

export type KeyValueMap = (key: string, value: any) => [string, any];

export class BaseDto<T> {
  constructor(partial?: Partial<T>) {
    if (partial) {
      this.setAll(partial);
    }
  }

  setAll(partial: Partial<T>): this {
    Object.assign(this, partial);
    return this;
  }

  setSort(key: string, orderBy: OrderByValue): this {
    Object.keys(this)
      .filter((attr) => attr.indexOf('orderBy') === 0)
      .forEach((attr) => {
        delete this[attr];
      });
    // const key = sort.active.replace(/^\w/, c => c.toUpperCase());
    // if (this['orderBy' + key]) {
    // this['orderBy' + key] = sort.direction.toUpperCase();
    this[key] = orderBy;
    // }
    return this;
  }

  filteredGet() {
    return this.__delete_empty(this);
  }

  __delete_empty(o: object, deep: boolean = true) {
    Object.keys(o).map((key) => {
      if (!Array.isArray(o[key]) && o[key] !== undefined && o[key] !== null && typeof o[key] === 'object') {
        this.__delete_empty(o[key], deep);
      } else if (o[key] === undefined || o[key] === null || o[key] === '') {
        delete o[key];
      }
    });
    return this;
  }

  cloneDeep(): T {
    return (cloneDeep(this) as unknown) as T;
  }
}
